import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router-dom'

import { usePreapprovalAmountPercentage } from '@hooks/usePreapprovalAmountPercentage'
import { IApplicationState } from '@store'
import { selectCampaignId } from '@store/router'
import { selectCostBreakdownMessage } from '@store/submissions'
import Theme from '@theme'
import { Container, Text } from '@tribegroup'

interface IProps {
  submissionId: number
}

const SubmissionCostBreakdownMessage: React.FC<IProps> = ({ submissionId }) => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match) as number
  const costBreakdownMessage = useSelector((state: IApplicationState) =>
    selectCostBreakdownMessage(state, submissionId, campaignId),
  )
  const preapprovalAmountPercentage = usePreapprovalAmountPercentage()
  return (
    <Container topOuterSpacing={1} data-testid="cost-breakdown-message-container">
      <Text italic color={Theme.grey800Color} block light>
        <FormattedMessage
          id={`costBreakdown.message.${costBreakdownMessage}`}
          values={{ preapprovalAmountPercentage }}
        />
      </Text>
    </Container>
  )
}

export default SubmissionCostBreakdownMessage
